import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=93867cd2&scoped=true&"
import script from "./Unauthorized.vue?vue&type=script&lang=js&"
export * from "./Unauthorized.vue?vue&type=script&lang=js&"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=93867cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93867cd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93867cd2')) {
      api.createRecord('93867cd2', component.options)
    } else {
      api.reload('93867cd2', component.options)
    }
    module.hot.accept("./Unauthorized.vue?vue&type=template&id=93867cd2&scoped=true&", function () {
      api.rerender('93867cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/Unauthorized.vue"
export default component.exports